import { ComponentType, FC, Suspense } from 'react';
import Loader from '../Loader';

// Lazy-route wrapper: while a route chunk loads, the global top loading bar is shown
// (fixed overlay — it never shifts the layout underneath).
export function Loadable<P extends object>(Component: ComponentType<P>): FC<P> {
	return (props: P) => (
		<Suspense fallback={<Loader />}>
			<Component {...props} />
		</Suspense>
	);
}
